<template>
	<div id="_status">


		::STATUS::<br>
		<div style="float:left">
			<div v-if="statusInfo.length" v-for="(location,index) in statusInfo" :class="'locationStatus '+location.status">
				Location: {{location.location}}<br>
				Status: {{location.status}}<br>
				Last Beat: {{location.lastBeat}}<br>
			</div>
		</div>
		

			
	</div>
</template>

<script>
import {bus} from '../main'

export default {
  name: 'STATUS',
  props: ['statusInfo'],
  data () {
    return {

    }
  },
  methods: {

  },
  created: function (){
	//console.log("satus created...")
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#_status{
	height:100px;
	background-color:gray;
	position:absolute;
	top:30px;
	left:0px;
	width:100%;
}

.locationStatus{
	width:150px;
	display:inline-block;
	border-radius:5px;
	background-color:lightgreen;
	margin:3px;
	text-align:left;
}

.OFFLINE{
	background-color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/STATUS.vue